import { takeLatest, put } from 'redux-saga/effects';
import { message } from 'antd';
import {
  getPayrunListSuccess, getPayrunListFail,
  getPayrunDetailsSuccess, getPayrunDetailsFail,
  getPayrunDtrListSuccess, getPayrunDtrListFail,
  doPayrunDtrUpdateSuccess, doPayrunDtrUpdateFail,
  getPayrunOTListSuccess, getPayrunOTListFail,
  doPayrunOTUpdateSuccess, doPayrunOTUpdateFail,
  getPayrunNDListSuccess, getPayrunNDListFail,
  doPayrunNDUpdateSuccess, doPayrunNDUpdateFail,
  getPayslipDetailsSuccess, getPayslipDetailsFail,
  sendPayslipSuccess, sendPayslipFail,
  getPayslipListSuccess, getPayslipListFail,
} from './payrunState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

import { showLoading, hideLoading } from '../layout/layoutState';
import { setCrudRoute } from '../crud/crudState';

const payrunService = createCrudService('api/v1/finance/payroll_payruns');
const payrunDtrService = createCrudService('api/v1/finance/payrun_dtrs');
const payrunOTService = createCrudService('api/v1/finance/payrun_overtimes');
const payrunNDService = createCrudService('api/v1/finance/payrun_night_differentials');
const redirectData = {route:'console/payrolls', mode: 'list', recordId:0 };
const modelName = 'Payroll Payrun';
const modelId = 'ppr_id';
const webPayslipService = createCrudService('protected/v1/my-payslip');
const protectedService = createCrudService('api/v1/protected');

function* getPayrunList(data) {
	yield doCrudCall(
		() => payrunService.getList(data.payload), 
		getPayrunListSuccess, 
		getPayrunListFail, null, null, LOADING_MSG);
}

function* getPayrunDetails(data) {
	yield doCrudCall(
		() => payrunService.getDetails(data.payload), 
		getPayrunDetailsSuccess, 
		getPayrunDetailsFail);	
}

function* doPayrunCreate(data){
	yield doCrudCall(
		() => payrunService.doCreate(data.payload), 
		getPayrunDetailsSuccess, 
		getPayrunDetailsFail,
		createRecordSuccess(modelName),
		null, SAVING_MSG);
}

function* doPayrunUpdate(data){
	yield doCrudCall(
		() => payrunService.doUpdate(data.payload[modelId], data.payload), 
		getPayrunDetailsSuccess, 
		getPayrunDetailsFail,
		updateRecordSuccess(modelName),
		null, UPDATING_MSG);
}

function* doPayrunDelete(data){
	yield doCrudCall(
		() => payrunService.doDelete(data.payload.recordId), 
		getPayrunDetailsSuccess, 
		getPayrunDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);
}

function* getPayrunDtrList(data) {
  try {
    const resp = yield payrunDtrService.getList(data.payload);
    yield put(getPayrunDtrListSuccess(resp.data));
  } catch (error) {
    console.error('Failed to fetch payrun list:', error); 
    yield put(getPayrunDtrListFail(error.toString()));
  }
}

function* getPayrunOTList(data) {
  try {
    const resp = yield payrunOTService.getList(data.payload);
    yield put(getPayrunOTListSuccess(resp.data));
  } catch (error) {
    console.error('Failed to fetch payrun list:', error); 
    yield put(getPayrunOTListFail(error.toString()));
  }
}

function* getPayrunNDList(data) {
  try {
    const resp = yield payrunNDService.getList(data.payload);
    yield put(getPayrunNDListSuccess(resp.data));
  } catch (error) {
    console.error('Failed to fetch payrun list:', error); 
    yield put(getPayrunNDListFail(error.toString()));
  }
}

function* doPayrollPayrunSync(data){
	try {
		
		const payrunId = data.payload;
		
		yield put(showLoading('Processing...'));

    	yield payrunService.doPostRequest(`resync/${payrunId}`, null);
    	message.success('Payrun re-sync completed.');
    	yield put(hideLoading());
    	yield put(setCrudRoute({...redirectData, mode: 'reload'}));
    	
  	} catch (error) {
		message.error(`Failed to perform operation: ${error}`);
    	yield put(hideLoading());
  	}
}

function* getPayslipDetails(data) {	
	const { empCode, payrollId, hash, securityCode } = data.payload;
	
	yield doCrudCall(
		() => webPayslipService.doPublicGetRequest(`${empCode}/${payrollId}/${hash}/${securityCode}`, null), 
		getPayslipDetailsSuccess, 
		getPayslipDetailsFail,
		null, null, LOADING_MSG);	
}

function* sendPayslip(data) {	
	try {		
		const payrunId = data.payload;		
		yield put(showLoading('Sending...'));

    	yield payrunService.doPostRequest(`send-payslip/${payrunId}`, null);
    	message.success('Payslip sent.');
    	yield put(hideLoading());    	
  	} catch (error) {
		message.error(`Failed to perform operation: ${error}`);
    	yield put(hideLoading());
  	}
}

function* doPayrunDtrUpdate(data){
	try {
		console.log(data.payload);
		const resp = yield payrunDtrService.doPostRequest(`override/hours`, data.payload);
		yield put(doPayrunDtrUpdateSuccess(resp.data));
	} catch (error) {
		yield put(doPayrunDtrUpdateFail(error.toString()));
	}
}

function* doPayrunOTUpdate(data){
	try {
		console.log('doPayrunOTUpdate');
		const resp = yield payrunOTService.doPostRequest(`override/hours`, data.payload);
		yield put(doPayrunOTUpdateSuccess(resp.data));
	} catch (error) {
		yield put(doPayrunOTUpdateFail(error.toString()));
	}
}

function* doPayrunNDUpdate(data){
	try {
		const resp = yield payrunNDService.doPostRequest(`override/hours`, data.payload);
		yield put(doPayrunNDUpdateSuccess(resp.data));
	} catch (error) {
		yield put(doPayrunNDUpdateFail(error.toString()));
	}
}

function* getPayslipList(data){
	yield doCrudCall(
		() => protectedService.doGetRequest('my-payslips', data.payload), 
		getPayslipListSuccess, 
		getPayslipListFail, null, null, LOADING_MSG);
}

function* payrunSaga() {
  yield takeLatest('payrun/getPayrunList', getPayrunList);
  yield takeLatest('payrun/getPayrunDetails', getPayrunDetails);
  yield takeLatest('payrun/doPayrunCreate', doPayrunCreate);
  yield takeLatest('payrun/doPayrunUpdate', doPayrunUpdate);
  yield takeLatest('payrun/doPayrunDelete', doPayrunDelete);  
  yield takeLatest('payrun/getPayrunDtrList', getPayrunDtrList);
  yield takeLatest('payrun/doPayrunDtrUpdate', doPayrunDtrUpdate);
  yield takeLatest('payrun/getPayrunOTList', getPayrunOTList);
  yield takeLatest('payrun/doPayrunOTUpdate', doPayrunOTUpdate);
  yield takeLatest('payrun/getPayrunNDList', getPayrunNDList);
  yield takeLatest('payrun/doPayrunNDUpdate', doPayrunNDUpdate);
  yield takeLatest('payrun/doPayrollPayrunSync', doPayrollPayrunSync);
  yield takeLatest('payrun/getPayslipDetails', getPayslipDetails);
  yield takeLatest('payrun/sendPayslip', sendPayslip);
  yield takeLatest('payrun/getPayslipList', getPayslipList);
  
}

export default payrunSaga;
